<template lang="pug">
  .component-credit-record-action-buttons(v-if="item")
    .dropdown-buttons
      PacketRecordUsageReveal(:item="item")
</template>
<script type="text/babel">

import ActionButton from '../ActionButton'
import PacketRecordUsageReveal from "./reveal/PacketRecordUsageReveal.vue";

export default {
  name: 'PacketRecordButtons',
  components: {PacketRecordUsageReveal, ActionButton},
  data() {
    return {}
  },
  created() {

  },
  methods: {},
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PacketRecordButtons.vue?6295a922